//
//
//
//
//
//
//
//
//

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'LoaderRing'
}
